import styled from "styled-components";

import { Tooltip } from "components/Tooltip";
import { Placeholder } from "components/Placeholder";
import { KeyStatsContainer } from "features/Strategy/v2/Detail/StrategyDetails.styles";

const KeyStatsPlaceholderContainer = styled.div`
  .stats-wrapper {
    flex: 1;
    text-align: right;
  }
  .name {
    margin-right: 0.5rem;
  }
`;

const KeyStatsPlaceholder = () => {
  return (
    <KeyStatsPlaceholderContainer>
      <KeyStatsContainer>
        <ul>
          {Array.from({ length: 10 }, (_, index) => (
            <li key={index}>
              <span className="key text-ellipsis">
                <Placeholder
                  col={{ lg: 6, xs: 8 }}
                  className="name"
                  as="span"
                />
                <Tooltip placement="auto" value={""} />
              </span>
              <span className="stats-wrapper">
                <Placeholder
                  className="stats"
                  col={{ lg: 4, xs: 6 }}
                  as="span"
                />
              </span>
            </li>
          ))}
        </ul>
      </KeyStatsContainer>
    </KeyStatsPlaceholderContainer>
  );
};

export default KeyStatsPlaceholder;
